var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-5 text-center"},[_c('font-awesome-icon',{staticClass:"mr-1 text-warning",attrs:{"icon":['fas', 'exclamation-triangle'],"size":"5x"}}),_c('h2',{staticClass:"mt-3"},[_vm._v("Klaida!")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }